import { Component, Inject, OnInit, signal, WritableSignal } from '@angular/core';
import { applicationsOverviewStateServiceInjectionToken } from "./applications-overview-state-service-injection-token";
import { ApplicationsOverviewStateService } from "./applications-overview-state.service";
import {
  ConfirmationModalService,
  confirmationModalServiceInjectionToken,
  EPageLayout,
  IToggleButton,
  PageLayoutComponent,
  ToggleButtonComponent
} from "@zaeper/angular-dashboard-view-lib";
import { MenuItem } from 'primeng/api';
import { ButtonModule } from "primeng/button";
import {
  createAppModalServiceInjectionToken
} from "../../modals/create-app-modal/create-app-modal-service-injection-token";
import { CreateAppModalService } from "../../modals/create-app-modal/create-app-modal.service";
import {
  createLauncherModalServiceInjectionToken
} from "../../modals/create-launcher-modal/create-launcher-modal-service-injection-token";
import { CreateLauncherModalService } from "../../modals/create-launcher-modal/create-launcher-modal.service";
import {
  createWidgetModalServiceInjectionToken
} from "../../modals/create-widget-modal/create-widget-modal-service-injection-token";
import { CreateWidgetModalService } from "../../modals/create-widget-modal/create-widget-modal.service";
import { AppsOverviewTabComponent } from './tabs/apps-overview-tab/apps-overview-tab.component';
import { LaunchersOverviewTabComponent } from './tabs/launchers-overview-tab/launchers-overview-tab.component';
import { WidgetsOverviewTabComponent } from './tabs/widgets-overview-tab/widgets-overview-tab.component';

@Component( {
  selector: 'applications-overview-page',
  templateUrl: 'applications-overview-page.component.html',
  imports: [
    AppsOverviewTabComponent, LaunchersOverviewTabComponent, WidgetsOverviewTabComponent,
    PageLayoutComponent, ToggleButtonComponent, ButtonModule
  ],
  providers: [
    {
      provide: applicationsOverviewStateServiceInjectionToken,
      useClass: ApplicationsOverviewStateService
    }, {
      provide: createAppModalServiceInjectionToken,
      useClass: CreateAppModalService
    }, {
      provide: createLauncherModalServiceInjectionToken,
      useClass: CreateLauncherModalService
    }, {
      provide: createWidgetModalServiceInjectionToken,
      useClass: CreateWidgetModalService
    }
  ]
} )
export class ApplicationsOverviewPageComponent implements OnInit {
  protected readonly activeIndex: WritableSignal<number> = signal( 0 );

  protected readonly navigation: MenuItem[];
  protected readonly toggleButtons: IToggleButton[];
  protected readonly ePageLayout = EPageLayout;

  constructor(
  ) {
    this.navigation = this._getNavigation();
    this.toggleButtons = this._getToggleButtons();
  }

  ngOnInit() {
  }

  public switchView(activeIndex: number) {
    this.activeIndex.set( activeIndex );
  }

  private _getToggleButtons(): IToggleButton[] {
    return [
      {
        label: "Apps"
      }, {
        label: "Launchers"
      }, {
        label: "Widgets"
      }
    ];
  }

  private _getNavigation(): MenuItem[] {
    return [
      {
        icon: "pi pi-home",
        routerLink: "/de/"
      }, {
        label: "Applikationen",
        routerLink: "/de/applications"
      }
    ];
  }
}
